import { render, staticRenderFns } from "./LedgerAccountForm.vue?vue&type=template&id=35d4778c"
import script from "./LedgerAccountForm.vue?vue&type=script&lang=js"
export * from "./LedgerAccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports